import { toISO } from "@/lib/api";

export const displayStatus = (b) => (b.status === "confirmed" && b.check_out < toISO(new Date()) ? "completed" : b.status);

const STATUS = {
  confirmed: "bg-[hsl(96_14%_86%)] text-[hsl(96_11%_24%)]", completed: "bg-[hsl(200_20%_90%)] text-[hsl(200_30%_25%)]",
  pending: "bg-[hsl(35_80%_90%)] text-[hsl(30_60%_30%)]", cancelled: "bg-secondary text-muted-foreground", expired: "bg-secondary text-muted-foreground",
  paid: "bg-[hsl(96_14%_86%)] text-[hsl(96_11%_24%)]", refunded: "bg-secondary text-muted-foreground", partially_refunded: "bg-[hsl(35_80%_90%)] text-[hsl(30_60%_30%)]",
};

export const StatusPill = ({ value, testid }) => (
  <span className={`text-xs px-2 py-1 rounded-full whitespace-nowrap ${STATUS[value] || "bg-secondary"}`} data-testid={testid}>{String(value).replace("_", " ")}</span>
);

export const matchesSearch = (b, q) => !q || [b.ref, b.name, b.email, b.phone].some((x) => (x || "").toLowerCase().includes(q.toLowerCase()));
